import React, { Component } from 'react';
import moment from 'moment';

import './ServiceRequestTimeslotPicker.scss';
import Icon from '../../components/Icon';

class ServiceRequestTimeslotPicker extends Component {
  state = {
    selectedSlotIndex: null,
    dayIndex: null
  };

  handleSlotSelection(index, x) {
    this.setState({selectedSlotIndex: index, dayIndex: x})
  }

  render() {
    const { availableServiceTimes, setFormData } = this.props;
    return (
      <div className="serviceRequestTimeslotPicker">
        <div className="serviceRequestTimeslotPicker__title">
          Open timeslots
        </div>
        <div >
          {availableServiceTimes.map((availableServiceTime, x) => (
            <div key={x}>
              <div className="serviceRequestTimeslotPicker__serviceTimes" >
              <div className="serviceRequestTimeslotPicker__day">
                {availableServiceTime.dayOfWeek}
              </div>
              <div className="serviceRequestTimeslotPicker__slots">
                  {availableServiceTime.slots.map((slot, index) => (
                    <button
                      key={index}
                      className={(this.state.selectedSlotIndex === index && this.state.dayIndex === x) ? "serviceRequestTimeslotPicker__slotSelected": "serviceRequestTimeslotPicker__slot"}
                      onClick={e => {
                        e.preventDefault();
                        this.handleSlotSelection(index, x);
                        setFormData({scheduledAt: slot});
                      }}
                    >
                      <div className="serviceRequestTimeslotPicker__bullet">
                        <Icon
                          glyph="check"
                          weight="regular"
                        />
                      </div>
                      <div  className="serviceRequestTimeslotPicker__details" >
                        <div className="serviceRequestTimeslotPicker__date">
                        {moment(slot, "YYYY-MM-DD HH:mm A").format("MMMM D")}
                        </div>
                        <div className="serviceRequestTimeslotPicker__time">
                        {moment(slot, "YYYY-MM-DD HH:mm A").format('h:mm A')}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
            </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ServiceRequestTimeslotPicker;
